import { render } from "./ImageMarcaUpload.vue?vue&type=template&id=0999039c&scoped=true"
import script from "./ImageMarcaUpload.vue?vue&type=script&lang=js"
export * from "./ImageMarcaUpload.vue?vue&type=script&lang=js"

import "./ImageMarcaUpload.vue?vue&type=style&index=0&id=0999039c&scoped=true&lang=css"

import exportComponent from "/home/geangeowle/Workspace/NT-Marketing-Digital/ecolatas/ecolatas-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0999039c"]])

export default __exports__